import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentModalConfig, ModalSize, SuiModal } from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';

interface IViewDepositSlipModalContext {
  documentPath: any;
}

@Component({
  selector: 'app-view-deposit-slip-modal',
  templateUrl: './view-deposit-slip-modal.component.html',
  styleUrls: ['./view-deposit-slip-modal.component.scss']
})
export class ViewDepositSlipModalComponent {

  baseUrl = environment.API_SERVER;
  safeImageUrl;
  documentPath;
  showMessage;

  constructor(
    public modal: SuiModal<IViewDepositSlipModalContext, void, void>,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private document

  ) {
    this.documentPath = this.modal.context.documentPath;
    this.safeImageUrl = this.sanitizer.bypassSecurityTrustUrl(`${this.baseUrl}/finance/public/media/?media=${this.documentPath}`);
    console.log(this.safeImageUrl);

  }
  ngOnInit() {
    this.document.body.classList.remove('panel');
    this.showMsg();
  }

  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }

  showMsg(){
    this.showMessage = false;
    setTimeout(()=>{
      this.showMessage = (!this.documentPath) ? true : false;
    }, 2000)
  }
}

export class ViewDepositSlipModal extends ComponentModalConfig<
  IViewDepositSlipModalContext,
  void,
  void
> {
  constructor(
    documentPath?: any,
    size: ModalSize = ModalSize.Small
  ) {
    super(ViewDepositSlipModalComponent, {documentPath: documentPath});

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'scale';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
    this.isCentered = true;
  }
}

